export const columnsStaticsData = [{
  accessor: 'underWatch',
  Header: '',
  hidden: false
}, {
  accessor: 'appName',
  Header: 'Application Name',
  hidden: false
}, {
  accessor: 'appType',
  Header: 'Application Type',
  hidden: false
}, {
  accessor: 'originRiskCategory',
  Header: 'Application Risk Category',
  hidden: false
}, {
  accessor: 'originRiskScore',
  Header: 'Application Risk Score',
  hidden: false
}, {
  accessor: 'envName',
  Header: 'Environment',
  hidden: false
}, {
  accessor: 'accountRiskScore',
  Header: 'Environment Risk Score',
  hidden: false
}, {
  accessor: 'accountRiskCategory',
  Header: 'Environment Risk Category',
  hidden: false
}, {
  accessor: 'objectArn',
  Header: 'Entity Arn',
  hidden: false
}, {
  accessor: 'objectName',
  Header: 'Entity Name',
  hidden: false
}, {
  accessor: 'objectType',
  Header: 'Entity Type',
  hidden: false
}, {
  accessor: 'entityRiskCategory',
  Header: 'Entity Risk Category',
  hidden: false
}, {
  accessor: 'entityRiskScore',
  Header: 'Entity Risk Score',
  hidden: false
}, {
  accessor: 'impactResult',
  Header: 'Recommendation',
  hidden: false
}];
export const columnsApplicationStaticsData = [{
  accessor: 'underWatch',
  Header: '',
  hidden: false
}, {
  accessor: 'appName',
  Header: 'Application Name',
  hidden: true
}, {
  accessor: 'appType',
  Header: 'Application Type',
  hidden: true
}, {
  accessor: 'originRiskCategory',
  Header: 'Application Risk Category',
  hidden: true
}, {
  accessor: 'originRiskScore',
  Header: 'Application Risk Score',
  hidden: true
}, {
  accessor: 'envName',
  Header: 'Environment',
  hidden: false
}, {
  accessor: 'accountRiskScore',
  Header: 'Environment Risk Score',
  hidden: false
}, {
  accessor: 'accountRiskCategory',
  Header: 'Environment Risk Category',
  hidden: false
}, {
  accessor: 'objectArn',
  Header: 'Entity Arn',
  hidden: false
}, {
  accessor: 'objectName',
  Header: 'Entity Name',
  hidden: false
}, {
  accessor: 'objectType',
  Header: 'Entity Type',
  hidden: false
}, {
  accessor: 'entityRiskCategory',
  Header: 'Entity Risk Category',
  hidden: false
}, {
  accessor: 'entityRiskScore',
  Header: 'Entity Risk Score',
  hidden: false
}, {
  accessor: 'impactResult',
  Header: 'Recommendation',
  hidden: false
}];
export const columnsEnvironmentStaticsData = [{
  accessor: 'underWatch',
  Header: '',
  hidden: false
}, {
  accessor: 'appName',
  Header: 'Application Name',
  hidden: true
}, {
  accessor: 'appType',
  Header: 'Application Type',
  hidden: true
}, {
  accessor: 'originRiskCategory',
  Header: 'Application Risk Category',
  hidden: true
}, {
  accessor: 'originRiskScore',
  Header: 'Application Risk Score',
  hidden: true
}, {
  accessor: 'envName',
  Header: 'Environment',
  hidden: true
}, {
  accessor: 'accountRiskScore',
  Header: 'Environment Risk Score',
  hidden: true
}, {
  accessor: 'accountRiskCategory',
  Header: 'Environment Risk Category',
  hidden: true
}, {
  accessor: 'objectArn',
  Header: 'Entity Arn',
  hidden: false
}, {
  accessor: 'objectName',
  Header: 'Entity Name',
  hidden: false
}, {
  accessor: 'objectType',
  Header: 'Entity Type',
  hidden: false
}, {
  accessor: 'entityRiskCategory',
  Header: 'Entity Risk Category',
  hidden: false
}, {
  accessor: 'entityRiskScore',
  Header: 'Entity Risk Score',
  hidden: false
}, {
  accessor: 'impactResult',
  Header: 'Recommendation',
  hidden: false
}];